module.exports = __webpack_public_path__ + "static/media/colorless.8812cfec.png";